import { takeEvery, call, put } from 'redux-saga/effects';
import {
    ADD_CSS,
    ADD_CSS_FAIL,
    ADD_CSS_START,
    ADD_CSS_SUCCESS,
    DELETE_CSS,
    DELETING_CSS,
    DELETING_CSS_FAIL,
    DELETING_CSS_SUCCESS,
    FETCH_CSS_RANGE_DATA,
    FETCH_CSS_RANGE_DATA_ERROR,
    FETCH_CSS_RANGE_DATA_FETCHING,
    FETCH_CSS_RANGE_DATA_SUCCESS,
    FETCH_LATEST_CSS,
    FETCH_LATEST_CSS_FAIL,
    FETCH_LATEST_CSS_FETCHING,
    FETCH_LATEST_CSS_SUCCESS
} from '../actions/criticalSwimSpeedActions';
import { gcApi } from '../config/axios';

export function* fetchLatestCSS(action) {
    try {
        const {
            payload: { startDate }
        } = action;

        yield put({
            type: FETCH_LATEST_CSS_FETCHING
        });

        const response = yield call(gcApi.get, `/biometric-service/criticalSwimSpeed/latest/${startDate}`);

        yield put({
            type: FETCH_LATEST_CSS_SUCCESS,
            latestCSS: response.data
        });
    } catch (e) {
        yield put({
            type: FETCH_LATEST_CSS_FAIL,
            latestCSS: null
        });
    }
}

export function* fetchCssReportData(action) {
    const { startDate, endDate, aggregation } = action;

    try {
        yield put({
            type: FETCH_CSS_RANGE_DATA_FETCHING
        });

        let url = `biometric-service/criticalSwimSpeed/range/${startDate}/${endDate}`;

        if (aggregation) {
            url += '/?aggregation=' + aggregation;
        }

        const response = yield call(gcApi.get, url);

        yield put({
            type: FETCH_CSS_RANGE_DATA_SUCCESS,
            data: response.data
        });
    } catch (e) {
        yield put({
            type: FETCH_CSS_RANGE_DATA_ERROR,
            data: []
        });
    }
}

export function* addCSS(action) {
    try {
        yield put({
            type: ADD_CSS_START
        });

        let url = `/biometric-service/criticalSwimSpeed`;
        const response = yield call(gcApi.post, url, {
            ...action.payload
        });

        //after updating the css value fetch the new value
        if (action.actionToDispatch && action.actionToDispatch.type) {
            yield put(action.actionToDispatch);
        }

        yield put({
            type: ADD_CSS_SUCCESS,
            response
        });
    } catch (e) {
        yield put({
            type: ADD_CSS_FAIL,
            data: {}
        });
    }
}

export function* deleteCSS({ cssValue, callback }) {
    try {
        yield put({
            type: DELETING_CSS
        });

        const calendarDate = cssValue.measurementTimestampLocal;
        const selectedVersion = cssValue.version;

        const response = yield call(
            gcApi.delete,
            `biometric-service/criticalSwimSpeed/${calendarDate}/${selectedVersion}`
        );

        // after updating the css value fetch the new value
        if (callback && callback.type) {
            yield put(callback);
        }

        yield put({
            type: DELETING_CSS_SUCCESS,
            data: response.data
        });
    } catch (e) {
        yield put({
            type: DELETING_CSS_FAIL,
            data: {}
        });
    }
}

// Watcher
export const cssReportsSagas = [
    takeEvery(FETCH_LATEST_CSS, fetchLatestCSS),
    takeEvery(FETCH_CSS_RANGE_DATA, fetchCssReportData),
    takeEvery(ADD_CSS, addCSS),
    takeEvery(DELETE_CSS, deleteCSS)
];
